(function($) {

    'use strict';
    
    $(document).ready(function() {
        //Si on est bien dans la page destination
        if($('body').hasClass('page-template-page-destination')){
            init();
            checkInput();
            initLoadMore();
        }
    });

    var init = function() {

        //zone
        var filterZone = $(' form input[type="checkbox"].checkbox-country');
        filterZone.on('change', manageZone);

        //subzone
        var $locations = $('.custom-dropdown__select.checkbox-subcountry');
        $locations.multiselect({
            buttonWidth: '160px',
            nonSelectedText: '',
            buttonText: function(options, select) {
                if (options.length === 0) {
                    return $(select).attr("data-selection");
                }
                // else if (options.length > 1) {
                else if (options.length > 0) {
                    // return $(select).attr("data-selection")+'...';
                    return $(select).attr("data-selection");
                }
                else {
                    var labels = [];
                    options.each(function() {
                        if ($(this).attr('label') !== undefined) {
                            labels.push($(this).attr('label'));
                        }
                        else {
                            labels.push($(this).html());
                        }
                    });
                    return labels.join(', ') + '';
                    return 'test';
                 }
            },
            onDropdownShow: function(event) {
                if( $(event.currentTarget).parent().hasClass('disabled') )
                    event.preventDefault();
            },
            onChange: function(option, checked, select) {
                manageLocation();
            }
        });

        //filter collapse
        $('.filter-open-btn a').on('click', function(e){
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $('.filter__advanced__hidden').slideToggle();
        });


        //order
        var filterOrder = $(' form select.select-order');
        filterOrder.on('change', manageOrder);


        //type
        var filterType = $(' form input[type="checkbox"].select-type');
        filterType.on('change', manageType);

        // date
        var datePicker = $(' form input.choose-date');
        var datePickerLang = datePicker.attr("lang");
        datePicker.datepicker({
            format: "d MM yyyy",
            language: datePickerLang,
            autoclose: true,
            clearBtn: true,
        });
        datePicker.datepicker().on('hide', function(e) {
            manageDate(event);
        });

       
        //duration
        var durationSlider = $( "#slider-range-length")[0];
        var tradDay = $(durationSlider).attr("data-day");
        var tradDays = $(durationSlider).attr("data-days");
        noUiSlider.create(durationSlider, {
            start: [1, 30],
            step: 1,
            connect: true,
            tooltips: true,
            range: {
                'min': 1,
                'max': 30
            },
            format: {
              to: function ( value ) {
                return Math.round(value) + " " + (value > 1  ? tradDays : tradDay);
              },
              from: function ( value ) {
                return value;
              }
            },
        });
        durationSlider.noUiSlider.on('change', function(values, handle) {
            manageDuration(event, values, handle);
        });


        //difficulty
        var difficultySlider = $( "#slider-range-difficulty")[0];
        var tradDifficulties = jQuery.parseJSON( $(difficultySlider).attr("data-difficulties") );
        noUiSlider.create(difficultySlider, {
            start: [1, 4],
            step: 1,
            connect: true,
            tooltips: true,
            range: {
                'min': 1,
                'max': 4
            },
            format: {
              to: function ( value ) {
                return tradDifficulties[value];
              },
              from: function ( value ) {
                return value;
              }
            },
        });
        difficultySlider.noUiSlider.on('change', function(values, handle) {
            manageDifficulty(event, values, handle);
        });


        //ambiance
        var filterAmbience = $('.filter-ambiance__bloc__listambiance li a');
        filterAmbience.on('click', function(e){
            e.preventDefault();
            //If we have less than 3 selected, we can add more
            if($('.filter-ambiance__bloc__listambiance li a.selected').length < 3){
                if(!$(this).hasClass('selected')){
                    $(this).addClass('selected');
                }
                else{
                    $(this).removeClass('selected');
                }
            }
            else{
                if($(this).hasClass('selected')){
                    $(this).removeClass('selected');
                }
            }
            $(this).blur();

            if( $('.filter-ambiance__bloc__listambiance li a.selected').length > 2 ) {

                $('.filter-ambiance__bloc__listambiance li a:not(.selected)').each( function() {
                    $(this).addClass('disabled');
                });
            }   else {
                $('.filter-ambiance__bloc__listambiance li a:not(.selected)').each( function() {
                    $(this).removeClass('disabled');
                });
            }
        });
        filterAmbience.on('click', manageAmbience);


        //landscape
        var filterLandscape = $('.filter-ambiance__bloc__listlandscape li a');
        filterLandscape.on('click', function(e){
            e.preventDefault();
            //If we have less than 3 selected, we can add more
            if($('.filter-ambiance__bloc__listlandscape li a.selected').length < 3){
                if(!$(this).hasClass('selected')){
                    $(this).addClass('selected');
                }
                else{
                    $(this).removeClass('selected');
                }
            }
            else{
                if($(this).hasClass('selected')){
                    $(this).removeClass('selected');
                }
            }
            $(this).blur();

            if( $('.filter-ambiance__bloc__listlandscape li a.selected').length > 2 ) {

                $('.filter-ambiance__bloc__listlandscape li a:not(.selected)').each( function() {
                    $(this).addClass('disabled');
                });
            }   else {
                $('.filter-ambiance__bloc__listlandscape li a:not(.selected)').each( function() {
                    $(this).removeClass('disabled');
                });
            }
        });
        filterLandscape.on('click', manageLandscape);

    };
    

    var manageOrder = function(e) {
        e.preventDefault();

        var query = QueryString();

        var currentSelect = $(e.target),
            currentOptionSelected = currentSelect.find('option:selected'),
            currentOptionValue = currentSelect.val() ? currentSelect.val() : '',
            currentSelectParamName = currentSelect.attr('name');

        if(currentSelect.val() == 'alpha') currentOptionValue = '';

        if(query[currentSelectParamName]) {
            delete query[currentSelectParamName];
        }
        // add param
        query = addNewQueryParam(query, currentOptionValue, currentSelectParamName);
        constructUrl(query);
    };


    var manageZone = function() {
        var query = QueryString();
        var cb = $(' form input[type="checkbox"].checkbox-country');
        var currentValue = [],
            currentParamName = 'zone';

        cb.each( function() {
            var sub = $(this).closest('.filter__countries__country').find('select.checkbox-subcountry')
            if( $(this).prop('checked') ) {
                currentValue.push( $(this).val());
            //     sub.multiselect('selectAll', false );
            // } else {
            //     sub.multiselect('deselectAll', false );
            }
        });
        
        if(query[currentParamName]) {
            delete query[currentParamName];
            delete query['destination'];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);
        // constructUrl(query, false, true);
        // manageLocation();

        constructUrl(query);
        
    };

    var manageLocation = function() {

        var query = QueryString();
        var options = $(' form select.checkbox-subcountry option');
        var currentValue = [],
            currentParamName = 'szone';
        var zone, zones = [];
        if( query['zone'] )
            zones = query['zone'].split(',');

        options.each( function() {
            if( $(this).is(':selected') ) {
                currentValue.push( $(this).val() );
                zone = $(this).val().split('_')[0];
                if( zones.indexOf(zone) == -1 )
                    zones.push(zone);
            }
        });
        query['zone'] = zones.join(',');

        if(query[currentParamName]) {
            delete query[currentParamName];
            delete query['destination'];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        // constructUrl(query, true, true);
        
        constructUrl(query);
    };


    var manageType = function(e) {
        e.preventDefault();

        var query = QueryString();
        var cb = $(' form input[type="checkbox"].select-type');
        var currentCheckbox = $(e.target),
            currentValue = [],
            currentParamName = currentCheckbox.attr('name');

            console.log('Manage type')

        cb.each( function() {
            if( $(this).prop('checked'))
                currentValue.push( $(this).val() );
        });

        if(query[currentParamName]) {
            delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
    };

    var manageDate = function(e) {

        var date = $(' form input.choose-date').datepicker('getDate');
        var fDate = null;
        if(date) {
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month < 10) month = '0' + month;
            var day = date.getDate();
            if (day < 10) day = '0' + day;
            var fDate = year + '-' + month + '-' + day;
        }

        var query = QueryString();
        var currentValue = [fDate],
            currentParamName = 'date';

        if(query[currentParamName]) {
             delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
        
    }


    var manageDuration = function(e, values, handle) {

        var start = values[0].split(' ')[0];
        var end = values[1].split(' ')[0];
        
        var query = QueryString();
        var currentValue = [start,end],
            currentParamName = 'duration';

        if(query[currentParamName]) {
            delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
        
    }

    var manageDifficulty= function(e, values, handle) {

        var difficultySlider = $( "#slider-range-difficulty")[0];
        var tradDifficulties = jQuery.parseJSON( $(difficultySlider).attr("data-difficulties") );

        var start = values[0];
        var end = values[1];
        
        $.each(tradDifficulties, function(i, v) {
            if(start == v) start = i;
            if(end == v) end = i;
        });

        var query = QueryString();
        var currentValue = [start,end],
            currentParamName = 'difficulty';

        if(query[currentParamName]) {
            delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
    }

    var manageAmbience = function(e) {
        e.preventDefault();

        var query = QueryString();
        var a = $('.filter-ambiance__bloc__listambiance li a');
        if(a.hasClass('disabled'))
            return;

        var currentValue = [],
            currentParamName = 'am';

        a.each( function() {
            if( $(this).hasClass('selected') )
                currentValue.push( $(this).attr('data-info') );
        });

        if(query[currentParamName]) {
            delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
    };

    var manageLandscape = function(e) {
        e.preventDefault();

        var query = QueryString();
        var a = $('.filter-ambiance__bloc__listlandscape li a');
        if(a.hasClass('disabled'))
            return;

        var currentValue = [],
            currentParamName = 'la';

        a.each( function() {
            if( $(this).hasClass('selected') )
                currentValue.push( $(this).attr('data-info') );
        });

        if(query[currentParamName]) {
            delete query[currentParamName];
        }

        // add param
        query = addNewQueryParam(query, currentValue.join(','), currentParamName);

        constructUrl(query);
    };


    var QueryString = function () {
        var query_string = {};
        var query = window.location.search.substring(1);

        if(query.length > 0) {
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                // If first entry with this name
                if (typeof query_string[pair[0]] === "undefined") {
                    query_string[pair[0]] = decodeURIComponent(pair[1]);
                    // If second entry with this name
                } else if (typeof query_string[pair[0]] === "string") {
                    var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
                    query_string[pair[0]] = arr;
                // If third or later entry with this name
                } else {
                    query_string[pair[0]].push(decodeURIComponent(pair[1]));
                }
            }
        } else {
            query_string = {};
        }

        return query_string;
    };

    var addNewQueryParam = function(listParam, newNalue, keyValue) {

        if(listParam[keyValue] !== undefined ) {
            // add new value to param already set

            if(listParam[keyValue].length > 0) {
                // parameter !empty
                var currentSchemaArray = listParam[keyValue].split(";");

                if(_.indexOf(currentSchemaArray, newNalue) < 0) {
                    // add id if is not yet
                    listParam[keyValue] += ';' + newNalue;
                }

            } else {
                // parameter empty
                listParam[keyValue] += newNalue;
            }

        } else {
            // add new param
            listParam[keyValue] = newNalue;
        }

        return listParam;
    };

    var constructUrl = function(query, submitEvent, preventAjax) {
        var currentUrl = window.location.href;
        var originUrl = window.location.href.split("?")[0];

        // Construct returned URL, base on object 'query'
        var paramNumber = 0;

        for (var param in query) {

            if (query[param].length <= 0)
                continue;
            
            if(paramNumber > 0) {
                originUrl += '&'
            } else {
                originUrl += '?'
            }

            paramNumber++;
            originUrl += param + '=' + query[param];
        }

        if(submitEvent) {
            window.location = originUrl;
        }

        if(preventAjax) {
            window.history.pushState({},"", originUrl);
            return;
        }

        $.post(
            ajaxurl,
            {
                'action': 'filter',
                'query': query,
                beforeSend: function( xhr ) {
                    //add loading
                    $('.results .contain-results').children().remove();
                    $('.contain-results').append('<div class="loading"></div>');
                },
            },
            function(response){
                $('.contain-results .loading').remove();
                var json = jQuery.parseJSON( response );
                $('.results .contain-results').append(json.contents);
                window.history.pushState({},"", originUrl);
                checkInput();
                updateNbResults(json.found_posts);
                enableLoadMore = true;
                currentPage = 1;
                totalPages = null;
                
            }
        );
    };


    var updateNbResults =  function(nbResults) {
        $('.nb-results .nb-results-value').hide();
        $('.nb-results .nb-results-none').hide();
        $('.nb-results .nb-results-one').hide();
        $('.nb-results .nb-results-many').hide();
        
        if(nbResults == 0)
            $('.nb-results .nb-results-none').show();

        else if(nbResults == 1) {
            $('.nb-results .nb-results-value').show();
            $('.nb-results .nb-results-value').text('1 ');
            $('.nb-results .nb-results-one').show();
        } else {
            $('.nb-results .nb-results-value').show();
            $('.nb-results .nb-results-value').text(nbResults + ' ');
            $('.nb-results .nb-results-many').show();
        }

    }


    var enableLoadMore = true;
    var currentPage = 1;
    var totalPages;
    var initLoadMore = function(max_num_pages) {
        
        var bottomOffset = 2000;
        $(window).scroll(function() {

            if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && enableLoadMore) {
                var data = {
                    'action': 'loadmore',
                    'query': QueryString(),
                    'paged' : ++currentPage,
                };
                $.ajax({
                    url : ajaxurl,
                    data: data,
                    type:'POST',
                    beforeSend: function( xhr ) {
                        enableLoadMore = false;
                        if(totalPages == null || currentPage <= totalPages)
                            $('.contain-results').append('<div class="loading"></div>');
                    },
                    success: function( response ) {
                        $('.contain-results .loading').remove();
                        var json = jQuery.parseJSON( response );
                        totalPages = json.max_num_pages;
                        if(currentPage > json.max_num_pages) return;
                            $('.results .contain-results').append(json.contents);
                            enableLoadMore = true;
                    }
                });
            }
        });
        
    }

    // =============================
    // Check Input management
    // =============================
    var checkInput = function() {
        var query = QueryString();

        //remove all zone & subzones
        $(' form input[type="checkbox"].checkbox-country').prop('checked', false);
        $(' form .filter__subzones').children().remove();

        for (var param in query) {

            // console.log(param, query[param])

            switch (param) {
                case 'o':
                    $(' form .select-order').val(query[param]);
                    break;

                case 'zone':
                    $(' form input[type="checkbox"].checkbox-country').each(function(index) {
                        if( query[param].indexOf ( $(this).val() ) !== -1) 
                            $(this).prop('checked', 'checked');
                        // manageZone();
                    });
                    break;
                
                case 'szone':
                    $(' form .checkbox-subcountry').multiselect('select', query[param].split(',') );
                    
                    // $(' form input[type="checkbox"].checkbox-country').each(function(index) {
                    //     if( query[param].indexOf ( $(this).val() ) !== -1)
                    //         $(this).prop('checked', 'checked');
                    // });

                    var options = $(' form select.checkbox-subcountry option');
                    options.each( function() {
                        if( $(this).is(':selected') ) {
                            var subzone = '<div class="subzone__item" value="'+ $(this).val() + '">' + $(this).text() + '<div class="subzone__button"></div></div>';
                            $('form .filter__subzones').append(subzone);
                            $('form .filter__subzones .subzone__item .subzone__button').on('click', function(e){
                                e.preventDefault();
                                $(' form .checkbox-subcountry').multiselect('deselect', $(this).parent().attr('value') );
                                $(this).parent().remove();
                                manageLocation();
                            });
                        }
                    });

                    break;

                case 'type':
                    $(' form .select-type').each(function(index) {
                        if( query[param].indexOf ( $(this).val() ) !== -1) 
                            $(this).prop('checked', 'checked');
                    });
                    break;

                case 'date':
                    $(' form input.choose-date').datepicker('setDate', new Date(query[param]));
                    break;    

                case 'duration':
                    $(' form #slider-range-length')[0].noUiSlider.set(query[param].split(','));
                    break;

                case 'difficulty':
                    $(' form #slider-range-difficulty')[0].noUiSlider.set(query[param].split(','));
                    break;    


                case 'am':
                    $(' form .filter-ambiance__bloc__listambiance li a').each(function(index) {
                        if( query[param].indexOf ( $(this).attr('data-info') ) !== -1) 
                           $(this).addClass('selected');
                    });
                    break;

                case 'la':
                    $(' form .filter-ambiance__bloc__listlandscape li a').each(function(index) {
                        if( query[param].indexOf ( $(this).attr('data-info') ) !== -1) 
                           $(this).addClass('selected');
                    });
                    break;    

            }
        }
    };


})(jQuery);